// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141635/js/" + chunkId + "." + {"44":"7058da5e","225":"43238b00","481":"3f310481","486":"bf96db77","770":"0a0e1dae"}[chunkId] + ".0.9149254971097165.chunk.js";
};